import React from "react";

export const GradeRange = ({ grades }) => {
  if (!grades || grades.length === 0) return "-";

  if (grades.length === 1) return grades[0];

  const from = grades[0];
  const to = grades[grades.length - 1];
  return `[${from}, ${to}]`;
};
